import { FC, useMemo, useRef } from "react";
// 组件
import { CopyOutlined } from '@ant-design/icons';
import { ProTooltip } from "../antd";
import CheckColumns from "./checkColumns";
import CopyPreview from "./copyPreview";
// 方法
import classNames from "classnames";
import { formatDataSource } from "./util";
import { responseMessage } from '../utils/messageUtils';
// 常量
import { ModalTableActionType } from "../constants/interface";
import { CopyTableDataProps, conditionType } from "./interface";
import './style.less';

/** 复制表格数据 */
const CopyTableData: FC<CopyTableDataProps> = props => {
  const { 
    className, style, dataSource, copyColumns, checkModalTitle, isMainSubTable, condition: outCondition,
    fileName, subDataKey, tooltip, formatFileName,
  } = props;
  const checkColumnsRef = useRef<ModalTableActionType>(); // 选择需要复制的字段
  const copyPreviewRef = useRef<ModalTableActionType>(); // 展示复制出来的数据
  /** 选择需要复制的字段 */
  const handleClick = () => {
    if (Array.isArray(dataSource) && dataSource.length) {
      checkColumnsRef.current?.show();
      return;
    }
    responseMessage('warning', '暂无可复制数据');
  };
  const handleOk = (fileldNames: string[], checkCondition: conditionType[]) => {
    const copyData = formatDataSource({
      dataSource,
      fileldNames,
      copyColumns,
      isMainSubTable,
      subDataKey,
      condition: checkCondition,
    });
    copyPreviewRef.current?.show(copyData);
  };
  const condition: conditionType[] = useMemo(() => {
    if (outCondition) return outCondition;
    if (isMainSubTable) return ['title', 'repeat', 'main', 'subTable'];
    return ['title', 'repeat',];
  }, [outCondition]);
  const classes = useMemo(() => {
    return classNames('copy-table-data-wrapper', className);
  }, [className]);
  const tooltipProps = useMemo(() => {
    if (tooltip) {
      if (typeof tooltip === 'string') {
        return {
          title: tooltip,
        };
      }
      return tooltip;
    }
  }, [tooltip]);

  return (
    <>
      <div
        className={classes}
        style={style}
        onClick={handleClick}
      >
        {
          tooltipProps ? (
            <ProTooltip {...tooltipProps}><CopyOutlined /></ProTooltip>
          ) : <CopyOutlined />
        }
      </div>
      <CheckColumns
        checkColumnsRef={checkColumnsRef}
        copyColumns={copyColumns}
        checkModalTitle={checkModalTitle}
        condition={condition}
        isMainSubTable={isMainSubTable}
        onOk={handleOk}
      />
      <CopyPreview
        copyPreviewRef={copyPreviewRef}
        fileName={fileName}
        formatFileName={formatFileName}
      />
    </>
  );
};

export default CopyTableData;
